(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-about"]) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var group = document.querySelector('[data-countup]');
  var captured = document.documentElement.classList.contains('capture');
  if(!group) return;
  var nums = [].slice.call(group.querySelectorAll('.ab-stat__num'));
  function runCount(){
    nums.forEach(function(el){
      var target = parseInt(el.getAttribute('data-count'), 10) || 0;
      if(reduce || captured){ el.textContent = target; return; }
      var dur = 1500, start = null;
      function tick(t){ if(start===null) start=t; var p=Math.min((t-start)/dur,1); var eased=1-Math.pow(1-p,3); el.textContent=Math.round(eased*target); if(p<1) requestAnimationFrame(tick); else el.textContent=target; }
      el.textContent='0'; requestAnimationFrame(tick);
    });
  }
  if('IntersectionObserver' in window && !captured){
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ runCount(); io.disconnect(); } }); }, { threshold:0.4 });
    io.observe(group);
  } else { runCount(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels"] && !Shopify.designMode) return;
  try {
    
/* Reels: autoplay + reveal-on-ready + manual-play fallback + mute/unmute.
   Lives in the section so it runs on every page the section is used. */
(function(){
  [].slice.call(document.querySelectorAll('[data-reels]')).forEach(function(reels){
    if (reels.hasAttribute('data-reels-init')) return; // never bind listeners twice
    reels.setAttribute('data-reels-init', '');
    var figs = [].slice.call(reels.querySelectorAll('.reel'));
    figs.forEach(function(fig){
      var v = fig.querySelector('[data-reel-video]');
      var muteBtn = fig.querySelector('[data-reel-mute]');
      var playBtn = fig.querySelector('[data-reel-play]');

      if (v) {
        var reveal = function(){ fig.classList.add('is-ready'); };
        // Reveal the video only once it can actually display a frame.
        if (v.readyState >= 2) { reveal(); }
        v.addEventListener('loadeddata', reveal);
        v.addEventListener('canplay', reveal);
        // On a hard error, keep the poster and do not offer a dead play button.
        v.addEventListener('error', function(){ if (playBtn) playBtn.hidden = true; });

        // Attempt muted autoplay; if blocked/rejected, keep poster + show play button.
        var attempt = function(){
          var p;
          try { p = v.play(); } catch (e) { p = null; }
          if (p && p.then) {
            p.then(function(){ if (playBtn) playBtn.hidden = true; reveal(); })
             .catch(function(){ if (playBtn) playBtn.hidden = false; });
          }
        };
        attempt();

        if (playBtn) {
          playBtn.addEventListener('click', function(){
            // Start muted unless the visitor has already unmuted this reel.
            if (!fig.classList.contains('is-unmuted')) v.muted = true;
            v.play().then(function(){ playBtn.hidden = true; reveal(); }).catch(function(){});
          });
        }
      }

      // Mute / unmute (one reel unmuted at a time). Stop propagation so the tap
      // is never consumed by the carousel scroll container or any parent.
      if (v && muteBtn) {
        muteBtn.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          var turnOn = v.muted; // was muted -> we are turning sound ON
          // Mute every other reel so only one plays audio at a time.
          figs.forEach(function(f){ if (f !== fig) muteReel(f); });
          if (turnOn) {
            v.muted = false;
            if (v.volume === 0) v.volume = 1;
            var pp = v.play(); // inside the click, so the browser allows sound
            if (pp && pp.catch) { pp.catch(function(){}); }
            fig.classList.add('is-unmuted');
            muteBtn.setAttribute('aria-label','Mute');
          } else {
            muteReel(fig);
          }
        });
      }
    });

    // Keep sound tied to the testimonial on screen: once an unmuted reel is mostly
    // scrolled or swiped out of view, mute it so its audio never plays under
    // another reel's heading and video.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.intersectionRatio < 0.5 && en.target.classList.contains('is-unmuted')) muteReel(en.target);
        });
      }, { threshold: [0, 0.5] });
      figs.forEach(function(f){ io.observe(f); });
    }
  });

  function muteReel(f){
    var fv = f.querySelector('[data-reel-video]');
    if (fv) fv.muted = true;
    f.classList.remove('is-unmuted');
    var mb = f.querySelector('[data-reel-mute]');
    if (mb) mb.setAttribute('aria-label','Unmute');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["traveller-lookbook"] && !Shopify.designMode) return;
  try {
    
(function () {
  function wire(car) {
    var track = car.querySelector('.tv-carousel__track');
    var nav = car.querySelector('.tv-carousel__nav');
    var arrows = car.querySelectorAll('.tv-arrow');
    var prev = arrows[0], next = arrows[1];
    if (!track) return;
    function page(){ return Math.max(track.clientWidth * 0.9, 1); }
    function refresh(){
      var ov = track.scrollWidth - track.clientWidth > 1;
      if (nav) nav.style.display = ov ? '' : 'none';
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });
    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    requestAnimationFrame(refresh);
    setTimeout(refresh, 400);
    if ('ResizeObserver' in window) { try { new ResizeObserver(refresh).observe(track); } catch (e) {} }
    refresh();
  }
  document.querySelectorAll('[data-tv-carousel]').forEach(wire);
})();

  } catch(e) { console.error(e); }
})();
})();
